import React from 'react'
import { Box, TextField, Button, Grid } from '@mui/material'
import AddressFields from 'components/AddressFields'
import NameFields from 'components/NameFields'

type SignupStep1FormProps = {
  formValues: any
  errors: any
  handleInputChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void
  handleBlur: (
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void
  handleSelectChange: (e: any) => void
  handleNext: () => void
  t: (key: string) => string
}

const SignUpStep1Form: React.FC<SignupStep1FormProps> = ({
  formValues,
  errors,
  handleInputChange,
  handleBlur,
  handleSelectChange,
  handleNext,
  t
}) => {
  return (
    <Box>
      <Grid item xs={12}>
        <TextField
          label={t('signup.email')}
          name='email'
          value={formValues.email}
          onChange={handleInputChange}
          onBlur={handleBlur}
          placeholder={t('signup.required')}
          fullWidth
          margin='dense'
          variant='outlined'
          required
          inputProps={{ maxLength: 50 }}
          error={Boolean(errors.email)}
          helperText={errors.email ? t('signup.emailInvalid') : ''}
        />
      </Grid>

      <NameFields
        formValues={{
          firstName: formValues.firstName,
          lastName: formValues.lastName
        }}
        errors={{
          firstName: errors.firstName,
          lastName: errors.lastName
        }}
        handleInputChange={handleInputChange}
        handleBlur={handleBlur}
        size={'medium'}
      />

      <Box display='flex' gap={2}>
        <TextField
          label={t('signup.phoneNumber')}
          name='phoneNumber'
          value={formValues.phoneNumber}
          onChange={handleInputChange}
          onBlur={handleBlur}
          placeholder={t('signup.required')}
          fullWidth
          margin='dense'
          variant='outlined'
          required
          error={errors.phoneNumber}
          helperText={errors.phoneNumber ? t('signup.phoneInvalid') : ''}
          inputProps={{ maxLength: 12 }}
        />
        <TextField
          label={t('signup.faxNumber')}
          name='faxNumber'
          value={formValues.faxNumber}
          onChange={handleInputChange}
          onBlur={handleBlur}
          placeholder={t('signup.optional')}
          fullWidth
          margin='dense'
          variant='outlined'
          error={errors.faxNumber}
          helperText={errors.faxNumber ? t('signup.faxInvalid') : ''}
          inputProps={{ maxLength: 12 }}
        />
      </Box>

      <Box display='flex' gap={2}>
        <TextField
          label={t('signup.companyName')}
          name='companyName'
          value={formValues.companyName}
          onChange={handleInputChange}
          onBlur={handleBlur}
          placeholder={t('signup.required')}
          fullWidth
          margin='dense'
          variant='outlined'
          required
          error={errors.companyName}
          helperText={errors.companyName ? t('signup.companyNameRequired') : ''}
          inputProps={{ maxLength: 50 }}
        />

        <TextField
          label={t('signup.taxId')}
          name='taxId'
          value={formValues.taxId}
          onChange={handleInputChange}
          onBlur={handleBlur}
          placeholder={t('signup.taxIdPlaceholder')}
          fullWidth
          margin='dense'
          variant='outlined'
          required
          error={errors.taxId}
          helperText={errors.taxId ? t('signup.taxIdInvalid') : ''}
          inputProps={{ maxLength: 10 }}
        />
      </Box>

      <AddressFields
        formValues={{
          addressLine1: formValues.addressLine1,
          addressLine2: formValues.addressLine2,
          city: formValues.city,
          state: formValues.state,
          zipCode: formValues.zipCode
        }}
        errors={{
          addressLine1: errors.addressLine1,
          city: errors.city,
          state: errors.state,
          zipCode: errors.zipCode
        }}
        handleInputChange={handleInputChange}
        handleBlur={handleBlur}
        handleSelectChange={handleSelectChange}
        size={'medium'}
      />

      <Box display='flex' justifyContent='space-between' mt={4}>
        <Box sx={{ width: '48%' }} />
        <Button
          variant='contained'
          color='primary'
          onClick={handleNext}
          sx={{ width: '48%' }}
        >
          {t('signup.nextButton')}
        </Button>
      </Box>
    </Box>
  )
}

export default SignUpStep1Form
